export const PERMISSIONS = {
  // transactions permissions
  CAN_VIEW_TRANSACTIONS: "can view transactions",
  // balance permissions
  CAN_VIEW_TRANSFERS: "can view transfers",
  // orders permissions
  CAN_VIEW_ORDERS: "can view orders",
  CAN_DELETE_ORDERS: "can delete orders",
  // chargebacks permissions
  CAN_HANDLE_CHARGE_BACKS: "can handle chargeback",
  // quick links permissions
  CAN_VIEW_QUICK_LINKS: "Can view payment link",
  CAN_CREATE_QUICK_LINKS: "Can add payment link",
  CAN_SHARE_QUICK_LINKS: "Can share payment link",
  CAN_CANCEL_QUICK_LINKS: "Can cancel payment link",
  // PayMe permissions
  CAN_VIEW_PAYMENT_HANDLE: "Can view payment handle",
  CAN_ADD_PAYMENT_HANDLE: "Can add payment handle",
  CAN_CHANGE_PAYMENT_HANDLE: "Can change payment handle",
  CAN_SHARE_PAYMENT_HANDLE: "Can share payment handle",
  CAN_ADD_BRANCH_HANDLE: "Can add branch handle",
  CAN_CHANGE_BRANCH_HANDLE: "Can change branch handle",
  // reach permissions
  CAN_VIEW_REACH: "PILOT | MERCHANT | Reach",
  // reports permissions
  CAN_EXPORT_REPORTS: "can export reports",
  CAN_DOWNLOAD_REPORTS: "can download reports",
  // terminals permissions
  CAN_VIEW_TERMINAL: "can view terminal",
  CAN_EXPORT_TERMINAL: "can export terminal",
  CAN_UPDATE_TERMINAL: "can update terminal",
  CAN_CREATE_TERMINAL_BRANCH: "can create terminal branch",
  // user management permissions
  CAN_VIEW_STAFF: "can view staff",
  CAN_CREATE_STAFF: "can create staff",
  CAN_DELETE_STAFF: "can delete staff",
  CAN_UPDATE_STAFF: "can update staff",
  // payment integrations permissions
  CAN_VIEW_PAYMENT_INTEGRATIONS: "can view payment integration",
  CAN_CREATE_PAYMENT_INTEGRATIONS: "can create payment integration",
  CAN_UPDATE_PAYMENT_INTEGRATIONS: "can update payment integration",
  // API Keys permissions
  CAN_VIEW_API_KEY: "Can view auth api key",
  CAN_UPDATE_API_KEY: "Can change auth api key",
  CAN_UPDATE_PUBLIC_SECRET_KEY: "Can change next user",
  CAN_VIEW_PUBLIC_SECRET_KEY: "Can view next user",
  // iframes permissions
  CAN_VIEW_IFRAMES: "can view iframe",
  // Chatbot permissions
  CAN_VIEW_CHATBOT: "PILOT | MERCHANT | AI Chat Bot",
  // Disputes permissions
  CAN_MANAGE_DISPUTES: "can manage dispute",
};